import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as filterReducers from '../reducers/filter.reducers';
import * as filterUtils from '@common/filter/filter-utils';
import {ListType} from "@common/enums/list-type";

const selectWidgetFiltersState =
  createFeatureSelector<filterReducers.WidgetFilterState>('widgetFilters');

export const {
  selectEntities: selectWidgetFilters,
} = filterReducers.widgetFiltersAdapter.getSelectors(selectWidgetFiltersState);

export const selectByWidgetId = (widgetId: string | number) =>
  createSelector(selectWidgetFilters, (entities) => entities[widgetId.toString()]);

export const getWidgetFilter = (widgetId: string | number) =>
  createSelector([selectByWidgetId(widgetId.toString())],
    (filterInstance: filterReducers.WidgetFilterInstance) =>
      filterInstance?.filter ?? filterUtils.getDefaultFilter());


const selectListTypeFiltersState =
  createFeatureSelector<filterReducers.ListTypeFilterState>('listTypeFilters');

export const {
  selectEntities: selectListTypeFilters,
} = filterReducers.listTypeFiltersAdapter.getSelectors(selectListTypeFiltersState)


export const selectByListType = (listType: ListType) =>
  createSelector(selectListTypeFilters, (entities) => entities[listType]);

export const getListTypeFilter = (listType: ListType) =>
  createSelector([selectByListType(listType)],
    (filterInstance: filterReducers.ListTypeFilterInstance) =>
      filterInstance?.filter ?? filterUtils.getDefaultFilter());
